const mediaItems = [
  {
    title: '《星际征途3》终极预告：4K震撼视觉',
    desc: '年度科幻巨制终极预告片，蓝光影视资源级别的视觉盛宴，每一帧都是壁纸。',
    duration: '02:38',
    views: '126万',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20trailer%20scene%20with%20explosive%20cosmic%20battle%20and%20dramatic%20orange%20nebula%20background%2C%20cinematic%20wide%20shot%2C%20intense%20lighting%20with%20golden%20and%20crimson%20tones%2C%20blockbuster%20film%20aesthetic&width=640&height=400&seq=media-01-scifi&orientation=landscape',
  },
  {
    title: '幕后花絮：《长安十二时辰》第二季拍摄揭秘',
    desc: '探班热门古装剧拍摄现场，了解高清电视剧背后的制作故事与精良服化道。',
    duration: '05:12',
    views: '89万',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20historical%20Chinese%20drama%20film%20set%20with%20costumes%20and%20ancient%20props%2C%20warm%20cinematic%20lighting%2C%20professional%20film%20production%20atmosphere%2C%20rich%20golden%20and%20earth%20tones&width=640&height=400&seq=media-02-behind&orientation=landscape',
  },
  {
    title: '解说推荐：2026暑期档观影指南',
    desc: '专业影评人为你解读暑期档必看清单，高清电影在线观看避坑指南。',
    duration: '08:45',
    views: '203万',
    img: 'https://readdy.ai/api/search-image?query=Film%20review%20studio%20setup%20with%20warm%20ambient%20lighting%20and%20movie%20posters%20on%20background%20wall%2C%20professional%20podcast%20aesthetic%2C%20golden%20hour%20tone%2C%20cozy%20cinematic%20atmosphere&width=640&height=400&seq=media-03-guide&orientation=landscape',
  },
  {
    title: '经典重温：《无间道》三部曲深度解析',
    desc: '港片巅峰之作全面解读，超清综艺播放级别的画质还原，重温梁朝伟刘德华巅峰对决。',
    duration: '12:20',
    views: '167万',
    img: 'https://readdy.ai/api/search-image?query=Noir%20style%20Hong%20Kong%20street%20scene%20with%20neon%20lights%20and%20rain-slicked%20pavement%2C%20dark%20cinematic%20atmosphere%2C%20film%20noir%20aesthetic%20with%20deep%20shadows%20and%20contrast%2C%20mysterious%20urban%20mood&width=640&height=400&seq=media-04-infernal&orientation=landscape',
  },
  {
    title: '纪录片精选：蓝色星球精彩片段集锦',
    desc: 'BBC经典自然纪录片高光时刻，超清画质下海洋世界的震撼与美丽。',
    duration: '04:55',
    views: '98万',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20ocean%20documentary%20scene%20with%20colorful%20coral%20reef%20and%20sunlight%20rays%20penetrating%20water%2C%20crystal%20clear%20blue%20tones%2C%20National%20Geographic%20style%20photography%2C%20peaceful%20and%20majestic&width=640&height=400&seq=media-05-ocean&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">精彩集锦</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">热门影视预告、花絮与解说推荐视频</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              onClick={(e) => e.preventDefault()}
              className="bg-background-100 rounded-lg overflow-hidden cursor-pointer group"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-all">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-900/70 text-white text-[10px] whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-2 text-[10px] text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}